/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { CSSProperties } from "react";

import { getLang, get } from "@/utils/use-lang";
import { GhostSettings } from "@/lib/ghost";
import { siteIcon } from "@/meta/siteDefaults";
import { useOverlay } from "@/components/Blog/contexts/overlayProvider";
import { SubscribeForm } from "@/components/Blog/SubscribeForm";

export const SubscribeOverlay = ({ settings }: { settings: GhostSettings }) => {
  const text = get(getLang(settings.lang));
  const { isOpen, handleClose } = useOverlay();

  const title = text(`SITE_TITLE`, settings.title);
  const siteLogo = settings.logo || siteIcon;
  const openingStyle: CSSProperties = { opacity: 1, pointerEvents: `auto` };
  const closingStyle: CSSProperties = { opacity: 0, pointerEvents: `none` };

  return (
    <div
      className="subscribe-overlay"
      style={isOpen ? openingStyle : closingStyle}
    >
      <a className="subscribe-close-overlay" onClick={handleClose} />
      <a className="subscribe-close-button" onClick={handleClose} />
      <div className="subscribe-overlay-content">
        {siteLogo && (
          <img className="subscribe-overlay-logo" src={siteLogo} alt={title} />
        )}
        <div className="subscribe-form">
          <h1 className="subscribe-overlay-title">
            {text(`SUBSCRIBE_TO`)} {title}
          </h1>
          <p className="subscribe-overlay-description">
            {text(`SUBSCRIBE_OVERLAY`)}
          </p>
          <SubscribeForm {...{ settings }} />
        </div>
      </div>
    </div>
  );
};
